import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import QuickNav from "@/components/layout/QuickNav";
import Hero from "@/components/home/Hero";
import ResearchShowcase from "@/components/home/ResearchShowcase";
import OurImpact from "@/components/home/OurImpact";
import HowItWorks from "@/components/home/HowItWorks";
import SuccessStories from "@/components/home/SuccessStories";
import CallToAction from "@/components/home/CallToAction";
import Programs from "@/components/home/Programs";
import GetInvolved from "@/components/home/GetInvolved";
import ClientPortalPreview from "@/components/home/ClientPortalPreview";
import BusinessImpact from "@/components/home/BusinessImpact";

export default function HomePage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <ResearchShowcase />
        <OurImpact />
        <HowItWorks />
        <BusinessImpact />
        <SuccessStories />
        <CallToAction />
        <Programs />
        <GetInvolved />
        <ClientPortalPreview />
      </main>
      <Footer />
      <QuickNav />
    </div>
  );
}
